import React from 'react';
import { Button } from 'kenshin';
import { CloseOutlined, DownloadOutlined } from '@ant-design/icons';
import { downloadFileUrl, getVideoCoverUrl } from '@/_util/util';
import './index.less';

const VideoPreview = ({ videoUrl, description, onClose }) => {
  const actionButtons = [
    // { label: '重新生成', icon: <RedoOutlined />, action: () => {} },
    {
      label: '下载',
      icon: <DownloadOutlined />,
      action: () => {
        downloadFileUrl(videoUrl);
      },
    },
    // { label: '删除', icon: <DeleteOutlined />, action: () => {} },
    // { label: '收录', icon: <StarOutlined />, action: () => {} },
  ];

  return (
    <div className="videoPreviewOverlay" onClick={onClose}>
      <div className="videoPreviewContent" onClick={(e) => e.stopPropagation()}>
        {/* 关闭按钮 */}
        <div className="closeBtn" onClick={onClose}>
          <CloseOutlined />
        </div>

        {/* 返回按钮 */}
        {/* <Button className="backBtn" onClick={onClose}>
          返回对话
        </Button> */}

        {/* 视频播放器 */}
        <div className="videoPlayer">
          <video src={videoUrl} className="videoElement" controls />
        </div>

        {/* 右侧操作区 */}
        <div className="sidePanel">
          {/* 缩略图 */}
          <div className="videoThumb">
            <img src={getVideoCoverUrl(videoUrl)} alt="视频封面" />
          </div>
          {description && (
            <div className="videoDesc">视频描述：{description}</div>
          )}

          {/* 操作按钮 */}
          <div className="actionButtons">
            {actionButtons.map((btn, idx) => (
              <Button key={idx} className="actionBtn" onClick={btn.action}>
                {btn.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VideoPreview;
